import React from "react";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";

export const OnboardingContext = React.createContext<
  | {
      changeStep: (
        step: OnboardingDetailedStep,
        queryToAppend?: Record<string, string>
      ) => void;
      backButtonTitle: string | undefined;
      onBackButtonClick: () => void;
      onFinishOnboarding: (
        nextPath?: string,
        queryToAppend?: Record<string, string>
      ) => void;
      finishOnboardingLoading: boolean;
      onSkipOnboarding?: (onSkipped?: () => void) => void;
    }
  | undefined
>(undefined);
